import api, { APIURL, errorHandle } from "../api/api"

class DashboardStat {
    constructor(obj) {
        this.newForms = obj.new_forms
        this.totalForms = obj.total_forms
        this.totalQueue = obj.total_queue
    }
}

export const getDashboardStatistic = () => {
    return new Promise((resolve, reject) => {
        api.get(APIURL.DASHBOARD_STAT)
            .then(response => {
                if (response.data.data) {
                    const obj = new DashboardStat(response.data.data)
                    resolve(obj)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export default DashboardStat